export interface GenesisClientAdminState {
    configuration: any;
}
